import { Fragment } from "react";

/**
 * The four Mahāvākyas — Great Sayings, one from each Veda. The philosophical
 * core of the Upaniṣads. Each entry is Devanagari + IAST + a brief translation
 * + its scriptural source. Rendered as a slow horizontal marquee, separated
 * by ॐ (Praṇava) as sacred punctuation.
 */
const MAHAVAKYAS = [
  {
    deva: "प्रज्ञानम् ब्रह्म",
    iast: "Prajñānam Brahma",
    gloss: "Consciousness is Brahman",
    source: "Aitareya Up. 3.1.3 — Ṛgveda",
  },
  {
    deva: "अहम् ब्रह्मास्मि",
    iast: "Ahaṃ Brahmāsmi",
    gloss: "I am Brahman",
    source: "Bṛhadāraṇyaka Up. 1.4.10 — Yajurveda",
  },
  {
    deva: "तत् त्वम् असि",
    iast: "Tat Tvam Asi",
    gloss: "That thou art",
    source: "Chāndogya Up. 6.8.7 — Sāmaveda",
  },
  {
    deva: "अयम् आत्मा ब्रह्म",
    iast: "Ayam Ātmā Brahma",
    gloss: "This Self is Brahman",
    source: "Māṇḍūkya Up. 1.2 — Atharvaveda",
  },
] as const;

function Phrase() {
  return (
    <>
      {MAHAVAKYAS.map((m) => (
        <Fragment key={m.deva}>
          <span className="marquee-pair">
            <span className="marquee-deva">{m.deva}</span>
            <span className="marquee-divider" aria-hidden />
            <span className="marquee-iast">{m.iast}</span>
            <span className="marquee-gloss">— {m.gloss}</span>
            <span className="marquee-source">{m.source}</span>
          </span>
          <span className="marquee-om" aria-hidden>
            ॐ
          </span>
        </Fragment>
      ))}
    </>
  );
}

export function Marquee() {
  return (
    <div
      className="marquee"
      aria-label="The four Mahāvākyas — great sayings of the Upaniṣads"
    >
      <div className="marquee-track">
        <span>
          <Phrase />
        </span>
        <span aria-hidden>
          <Phrase />
        </span>
      </div>
    </div>
  );
}
